import { ScanInfo } from '../../OrderScanPicking/ScanInfo'
import { Icon, Label } from 'semantic-ui-react'
import { CustomerAckType } from './CustomerAckType'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { OrderItemQuantity } from '../OrderItemQuantity'


const FulfillmentState = ({orderItem, scanValue}) => {
    const [t] = useTranslation()

    return (
      <>

          {!orderItem.customerAckType && orderItem.fulfillmentAction === 'ALTERNATIVE_ITEM' && (
             <Label
            size="mini"
            color={orderItem.fulfillmentIssue ? "grey":"yellow"}
          >
              <Icon name="user"/>
              {t('order.fulfillment_action.ALTERNATIVE_ITEM')}
          </Label>
          )}

          <ScanInfo orderItem={orderItem} scanValue={scanValue}/>
          {!orderItem.pickingMethod && orderItem.fulfillmentAction === 'CANCEL_ORDER' && (
            <Label size='mini' color='yellow'>
              {t('order.fulfillment_action.CANCEL_ORDER')}
            </Label>)}
          {orderItem.pickingMethod === 'MANUAL' &&
            <Label size='mini' icon='hand paper outline' color='green'>
                <Icon name="hand paper outline"/>
                {t('order.pickup.manual_label')}
                {orderItem.quantity &&
                  <>
                      <Icon style={{ margin: '0 .5rem' }} name="long arrow alternate right"/>
                      <OrderItemQuantity
                        orderItem={orderItem}
                        quantity={orderItem.quantity}
                      />
                  </>
                }
            </Label>
          }


          {orderItem.customerAckType &&
            <CustomerAckType
              customerAckType={orderItem.customerAckType}
            />
          }
      </>
    )
}

FulfillmentState.propTypes = {
    orderItem: PropTypes.object.isRequired,
    scanValue: PropTypes.number,
}

export { FulfillmentState }
